jQuery(document).ready(function($){
  var controller = new ScrollMagic.Controller();
  var scenesArray = [];

  if($('.wf-scientifically-proven').length) {

    // first scene to display the main section
    // scenesArray.push(new ScrollMagic.Scene({
    //   triggerElement: '.wf-scientifically-proven'
    // })
    // .setClassToggle('.wf-scientifically-proven, .wf-scientifically-proven', 'show')
    // .reverse(false)
    // // .addIndicators()
    // .addTo(controller)
    // );

    // second scene to display the diamond shapes
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: '.wf-scientifically-proven .headline'
    })
    .setClassToggle('.wf-scientifically-proven .headline, .wf-scientifically-proven .callout-item', 'show')
    .reverse(false)
    // .addIndicators()
    .addTo(controller)
    );

    // $('.wf-scientifically-proven .callout-item').each(function() {
    //
    //   console.log('#'+$(this).attr('id'));
    //
    //   scenesArray.push(new ScrollMagic.Scene({
    //     triggerElement: '#'+$(this).attr('id')
    //   })
    //   .setClassToggle('#'+$(this).attr('id'), 'show')
    //   .reverse(false)
    //   .addIndicators()
    //   .addTo(controller)
    //   );
    // });

  }
});
